(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('menu-countdown')) return;
    class MenuCountdown extends HTMLElement {
      connectedCallback() {
        this.timer = this.querySelector('[data-timer]');
        this.closedMessage = this.querySelector('[data-closed]');
        this.message = this.querySelector('[data-message]');
        this.pickup = this.querySelector('[data-pickup]');
        this.deadlineText = this.querySelector('[data-deadline-text]');
        this.pickupDate = this.querySelector('[data-pickup-date]');
        this.units = {
          days: this.querySelector('[data-days]'), hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'), seconds: this.querySelector('[data-seconds]')
        };
        this.locale = this.dataset.locale || document.documentElement.lang || 'fr';
        this.timeZone = 'Europe/Brussels';
        this.render();
        this.interval = window.setInterval(() => this.render(), 1000);
      }
      disconnectedCallback() { window.clearInterval(this.interval); }
      getNextDeadline(now) {
        const values = Array.from(this.querySelectorAll('[data-deadline-candidate]')).map((item) => item.dataset.deadlineCandidate);
        if (this.dataset.deadlineCandidate) values.push(this.dataset.deadlineCandidate);
        const deadlines = values.map((value) => {
          const normalized = String(value || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
          return new Date(normalized).getTime();
        }).filter((value) => Number.isFinite(value) && value > now);
        return deadlines.length ? Math.min(...deadlines) : null;
      }
      updateDateLabels() {
        const deadline = new Date(this.deadline);
        if (this.deadlineText) {
          this.deadlineText.dateTime = deadline.toISOString();
          this.deadlineText.textContent = new Intl.DateTimeFormat(this.locale, {
            timeZone: this.timeZone, weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
          }).format(deadline);
        }
      }
      closeMenu() {
        if (this.timer) this.timer.hidden = true;
        if (this.message) this.message.hidden = true;
        if (this.closedMessage) this.closedMessage.hidden = false;
        document.querySelectorAll("form[action*='/cart/add'] button[type='submit'], form[action*='/cart/add'] button[name='add'], .shopify-payment-button button").forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        });
      }
      render() {
        const now = Date.now();
        const nextDeadline = this.getNextDeadline(now);
        if (nextDeadline !== this.deadline) {
          this.deadline = nextDeadline;
          if (this.deadline) this.updateDateLabels();
        }
        if (!this.deadline) {
          this.closeMenu();
          window.clearInterval(this.interval);
          return;
        }
        if (this.closedMessage) this.closedMessage.hidden = true;
        if (this.timer) this.timer.hidden = false;
        if (this.message) this.message.hidden = false;
        const seconds = Math.floor((this.deadline - now) / 1000);
        if (this.units.days) this.units.days.textContent = String(Math.floor(seconds / 86400)).padStart(2, '0');
        if (this.units.hours) this.units.hours.textContent = String(Math.floor((seconds % 86400) / 3600)).padStart(2, '0');
        if (this.units.minutes) this.units.minutes.textContent = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
        if (this.units.seconds) this.units.seconds.textContent = String(seconds % 60).padStart(2, '0');
      }
    }
    customElements.define('menu-countdown', MenuCountdown);
  })();
  } catch(e) { console.error(e); }
})();

})();
